import { Fragment } from 'react';
import cx from 'classnames';

import Icon from 'components/Icon';
import { isDataAvailable } from 'utils/common.utils';

import styles from './Lists.module.scss';

type StatType = {
  title: string;
  value?: string;
};

type LinkStatType = {
  title: string;
  url: string;
  description: string;
};

export const BulletList = ({
  className,
  size = 'small',
  title,
  items,
  listStyleType = 'circle',
  hideTitle,
}: {
  className?: string;
  size?: 'small' | 'large';
  title: string;
  items: StatType[];
  listStyleType?: 'circle' | 'tick';
  hideTitle?: boolean;
}) => {
  const filteredItems = items.filter((item) => isDataAvailable(item.title));
  if (filteredItems.length === 0) return null;

  return (
    <div className={cx(styles['list-container'], className, [styles[size]])}>
      {!hideTitle && <h3 className={styles.subtitle}>{title}</h3>}
      <ul className={styles['bullet-list']}>
        {filteredItems.map((item, index) => (
          <li key={index} className={styles['bullet-list-item']}>
            {listStyleType === 'circle' && (
              <span className={styles['bullet-circle']}></span>
            )}
            {listStyleType === 'tick' && (
              <Icon
                iconName="icon_tick-mark"
                size="xsmallplus"
                className={styles['bullet-tick']}
              />
            )}
            <div className={styles['list-content']}>
              <h4 className={styles.label}>{item.title}</h4>
              <p className={styles.value}>{item.value}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const LinkList = ({
  className,
  size = 'small',
  title,
  items,
  hideTitle,
}: {
  className?: string;
  size?: 'small' | 'large';
  title: string;
  items: LinkStatType[];
  hideTitle?: boolean;
}) => {
  const filteredItems = items.filter(
    (item) => isDataAvailable(item.title) && isDataAvailable(item.url)
  );
  if (filteredItems.length === 0) return null;

  return (
    <div className={cx(styles['list-container'], className, [styles[size]])}>
      {!hideTitle && <h3 className={styles.subtitle}>{title}</h3>}
      <ul className={styles['link-list']}>
        {filteredItems.map((item, index) => (
          <Fragment key={index}>
            <li className={styles['link-list-item']}>
              <a
                className={styles.link}
                target="_blank"
                href={item.url}
                rel="noreferrer"
              >
                {item.title}
              </a>
              {item.description && (
                <p className={styles.description}>{item.description}</p>
              )}
            </li>
            {index !== items.length - 1 && (
              <div className={styles.divider}></div>
            )}
          </Fragment>
        ))}
      </ul>
    </div>
  );
};
